/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { MembershipUsersResponse } from '../model';
// @ts-ignore
import { PartnerUserBriefResponse } from '../model';
// @ts-ignore
import { RegisterUserByAdminResponse } from '../model';
// @ts-ignore
import { RegisterUserIntoMembershipByAdminRequest } from '../model';
/**
 * AdminMembershipControllerApi - axios parameter creator
 * @export
 */
export const AdminMembershipControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} phoneNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkMembershipByAdmin: async (phoneNumber: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phoneNumber' is not null or undefined
            assertParamExists('checkMembershipByAdmin', 'phoneNumber', phoneNumber)
            const localVarPath = `/admin/memberships/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (phoneNumber !== undefined) {
                localVarQueryParameter['phoneNumber'] = phoneNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} membershipId 
         * @param {RegisterUserIntoMembershipByAdminRequest} registerUserIntoMembershipByAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserIntoMembershipByAdmin: async (membershipId: string, registerUserIntoMembershipByAdminRequest: RegisterUserIntoMembershipByAdminRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'membershipId' is not null or undefined
            assertParamExists('createUserIntoMembershipByAdmin', 'membershipId', membershipId)
            // verify required parameter 'registerUserIntoMembershipByAdminRequest' is not null or undefined
            assertParamExists('createUserIntoMembershipByAdmin', 'registerUserIntoMembershipByAdminRequest', registerUserIntoMembershipByAdminRequest)
            const localVarPath = `/admin/memberships/{membershipId}/users`
                .replace(`{${"membershipId"}}`, encodeURIComponent(String(membershipId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerUserIntoMembershipByAdminRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} membershipId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersOfMembershipByAdmin: async (membershipId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'membershipId' is not null or undefined
            assertParamExists('getUsersOfMembershipByAdmin', 'membershipId', membershipId)
            const localVarPath = `/admin/memberships/{membershipId}/users`
                .replace(`{${"membershipId"}}`, encodeURIComponent(String(membershipId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminMembershipControllerApi - functional programming interface
 * @export
 */
export const AdminMembershipControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminMembershipControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} phoneNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkMembershipByAdmin(phoneNumber: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MembershipUsersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkMembershipByAdmin(phoneNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} membershipId 
         * @param {RegisterUserIntoMembershipByAdminRequest} registerUserIntoMembershipByAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUserIntoMembershipByAdmin(membershipId: string, registerUserIntoMembershipByAdminRequest: RegisterUserIntoMembershipByAdminRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisterUserByAdminResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUserIntoMembershipByAdmin(membershipId, registerUserIntoMembershipByAdminRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} membershipId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersOfMembershipByAdmin(membershipId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PartnerUserBriefResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsersOfMembershipByAdmin(membershipId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminMembershipControllerApi - factory interface
 * @export
 */
export const AdminMembershipControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminMembershipControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} phoneNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkMembershipByAdmin(phoneNumber: string, options?: any): AxiosPromise<MembershipUsersResponse> {
            return localVarFp.checkMembershipByAdmin(phoneNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} membershipId 
         * @param {RegisterUserIntoMembershipByAdminRequest} registerUserIntoMembershipByAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserIntoMembershipByAdmin(membershipId: string, registerUserIntoMembershipByAdminRequest: RegisterUserIntoMembershipByAdminRequest, options?: any): AxiosPromise<RegisterUserByAdminResponse> {
            return localVarFp.createUserIntoMembershipByAdmin(membershipId, registerUserIntoMembershipByAdminRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} membershipId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersOfMembershipByAdmin(membershipId: string, options?: any): AxiosPromise<Array<PartnerUserBriefResponse>> {
            return localVarFp.getUsersOfMembershipByAdmin(membershipId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminMembershipControllerApi - object-oriented interface
 * @export
 * @class AdminMembershipControllerApi
 * @extends {BaseAPI}
 */
export class AdminMembershipControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} phoneNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminMembershipControllerApi
     */
    public checkMembershipByAdmin(phoneNumber: string, options?: AxiosRequestConfig) {
        return AdminMembershipControllerApiFp(this.configuration).checkMembershipByAdmin(phoneNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} membershipId 
     * @param {RegisterUserIntoMembershipByAdminRequest} registerUserIntoMembershipByAdminRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminMembershipControllerApi
     */
    public createUserIntoMembershipByAdmin(membershipId: string, registerUserIntoMembershipByAdminRequest: RegisterUserIntoMembershipByAdminRequest, options?: AxiosRequestConfig) {
        return AdminMembershipControllerApiFp(this.configuration).createUserIntoMembershipByAdmin(membershipId, registerUserIntoMembershipByAdminRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} membershipId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminMembershipControllerApi
     */
    public getUsersOfMembershipByAdmin(membershipId: string, options?: AxiosRequestConfig) {
        return AdminMembershipControllerApiFp(this.configuration).getUsersOfMembershipByAdmin(membershipId, options).then((request) => request(this.axios, this.basePath));
    }
}

